define(["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.uniqueId = void 0;

  var uniqueId = function uniqueId() {
    return Math.random().toString(36).substring(2) + new Date().getTime().toString(36);
  };

  _exports.uniqueId = uniqueId;
});